import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
const LeaveTemplateForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "40%",
      borderRadius: "5px",
      maxWidth: "400px",
      maxHeight: "500px",
      height: "100%",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});

  const [leaveData, setLeaveData] = useState([]);
  const [years, setYears] = useState([]);
  const [leaveTypeData, setLeaveTypeData] = useState([]);
  const [selectedYearId, setSelectedYearId] = useState("");
  const [leaveTemplateDetails, setLeaveTemplateDetails] = useState([]);
  const [update, setUpdate] = useState(false);

  const { sendRequest: getYears } = useHttp();

  useEffect(() => {
    getYears(
      {
        url: `/api/financialYear/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        setYears(res);
      }
    );
  }, []);

  const { sendRequest: getleaveType } = useHttp();

  useEffect(() => {
    getleaveType(
      {
        url: `/api/leaveType/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        setLeaveTypeData(res);
      }
    );
  }, []);

  const handleLeaveCountChange = (e, leaveTypeId) => {
    const updatedDetails = [...leaveTemplateDetails];
    const index =
      updatedDetails &&
      updatedDetails.findIndex((item) => item.leaveTypeId === leaveTypeId);

    if (index !== -1) {
      updatedDetails[index].leaveCount = parseInt(e.target.value) || 0;
    } else {
      updatedDetails &&
        updatedDetails.push({
          leaveCount: parseInt(e.target.value) || 0,
          status: 1,
          leaveTypeId,
        });
    }

    const allLeaveTypeIds =
      leaveTypeData && leaveTypeData.map((item) => item.leaveTypeId);
    const updatedJSON =
      allLeaveTypeIds &&
      allLeaveTypeIds.map((typeId) => {
        const detail =
          updatedDetails &&
          updatedDetails.find((item) => item.leaveTypeId === typeId);
        return {
          leaveCount: detail ? detail.leaveCount : 0,

          status: 1,
          leaveTypeId: typeId,
        };
      });

    setLeaveTemplateDetails(updatedDetails);
  };

  const { sendRequest: postLeaveTemplate } = useHttp();
  const submitHandler = (e) => {
    e.preventDefault();
    if (!update) {
      const isLeaveTemplateExists =
        leaveData &&
        leaveData.some(
          (template) => template.financialYearId == selectedYearId
        );
      if (isLeaveTemplateExists) {
        toast.error("Leave template already exists for this financial year.");
        return;
      }
    }

    const financialYearName =
      years &&
      years.find((item) => item.financialYearId == selectedYearId)
        ?.financialYearName;

    const input = {
      leaveTemplateDetails: leaveTemplateDetails,
      leaveTemplateName: "Leave Template " + financialYearName,
      status: 1,
      financialYearId: selectedYearId,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
      serviceId: props.sId,
    };

    if (update) {
      input["leaveTemplateId"] = update.leaveTemplateId;
    }

    postLeaveTemplate(
      {
        url: "/api/leaveTemplate/",
        method: update ? "PUT" : "POST",

        body: input,
      },
      (data) => {
        toast.success(`Leave Template ${update ? "Updated" : "Added"}`);

        props.addForm(false);
      }
    );
  };

  const handleEdit = (data) => {
    setUpdate(data);

    setLeaveTemplateDetails(data.leaveTemplateDetails);

    leaveTypeData.forEach((leaveType) => {
      const leaveCountInput = document.getElementById(
        `leaveCount_${leaveType.leaveTypeId}`
      );
      const matchingDetail =
        data.leaveTemplateDetails &&
        data.leaveTemplateDetails.find(
          (detail) => detail.leaveTypeId === leaveType.leaveTypeId
        );
      leaveCountInput.value = matchingDetail ? matchingDetail.leaveCount : "";
    });

    setSelectedYearId(data.financialYearId);
  };

  const { sendRequest: deleteLeaveTemplate } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Leave Template detail?",
      onOk() {
        const updatedData = {
          ...data,
          status: 0,
        };

        deleteLeaveTemplate(
          {
            url: "/api/leaveTemplate/",
            method: "PUT",
            body: updatedData,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            leaveDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const { sendRequest: getleaveDetail } = useHttp();

  const leaveDetail = () => {
    getleaveDetail(
      {
        url: `/api/leaveTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        setLeaveData(res);
      }
    );
  };

  useEffect(() => {
    leaveDetail();
  }, []);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const offset = currentPage * itemsPerPage;

  const displayedItems =
    leaveData && leaveData.slice(offset, offset + itemsPerPage);

  const [isModalopen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState();

  const openModal = (data) => {
    setSelectedData(data);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Leave Template</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Financial Year</label>
                        <select
                          id="financialYear"
                          className="form-control"
                          ref={(el) => (frmRef.current["financialYear"] = el)}
                          required
                          style={{
                            height: "35px",
                            width: "160px",
                            borderRadius: "5px",
                          }}
                          onChange={(e) => setSelectedYearId(e.target.value)}
                          value={selectedYearId}
                        >
                          <option value="">Select</option>
                          {years &&
                            years.map((x) => (
                              <option
                                key={x.financialYearId}
                                value={x.financialYearId}
                              >
                                {x.financialYearName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Leave Type</th>
                            <th>Leave Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {leaveTypeData &&
                            leaveTypeData.map((x, i) => (
                              <tr key={i}>
                                <td>{x.leaveTypeName}</td>
                                <td>
                                  <input
                                    type="text"
                                    id={`leaveCount_${x.leaveTypeId}`}
                                    className="form-control"
                                    value={
                                      leaveTemplateDetails
                                        ? leaveTemplateDetails.leaveCount
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleLeaveCountChange(e, x.leaveTypeId)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>{" "}
                    <div className="col-md-2"> </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default LeaveTemplateForm;
